import React, { useState, useEffect } from "react";
import {
  Container,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Box,
  Grid,
  Typography,
  Snackbar,
  Alert,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import { styled, keyframes } from "@mui/system";
import apiPrakasak from "../../api/apiPrakasak";

const slideIn = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const StyledAlert = styled(Alert)(({ theme }) => ({
  height: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.2rem",
  animation: `${slideIn} 0.5s ease-out`,
}));

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export default function UserAllocation() {
  const [formData, setFormData] = useState({
    district: "",
    block: "",
    cluster: "",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    username: "",
  });
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [consultants, setConsultants] = useState([]);
  console.log(consultants,"consultants------>")
  const [selectedConsultantId, setSelectedConsultantId] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const years = Array.from(
    { length: new Date().getFullYear() - 2022 + 1 },
    (v, k) => 2023 + k
  );

  useEffect(() => {
    if (!formData.username) return;
    const fetchDistricts = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get("getAllDistricts");
        if (response?.data) {
          setDistricts(response.data.map((item) => item.district));
        }
      } catch (error) {
        handleSnackbar("Failed to fetch districts.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchDistricts();
  }, [formData.username]);

  useEffect(() => {
    if (!formData.district) return;
    const fetchBlocks = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get(
          `getAllBlocksByDistrict/${formData.district}`
        );
        if (response?.data) {
          setBlocks(response.data.map((item) => item.block));
        }
      } catch (error) {
        handleSnackbar("Failed to fetch blocks.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchBlocks();
  }, [formData.district]);

  useEffect(() => {
    if (!formData.block) return;
    const fetchClusters = async () => {
      setLoading(true);
      try {
        const response = await apiPrakasak.get(
          `getAllClustersByBlock/${formData.block}`
        );
        if (response?.data) {
          setClusters(response.data.map((item) => item.cluster));
        }
      } catch (error) {
        handleSnackbar("Failed to fetch clusters.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchClusters();
  }, [formData.block]);

  const fetchConsultants = async () => {
    try {
      const response = await apiPrakasak.get(`getAllConsultants`);
      const consultants = response.data.map((consultant) => ({
        consultantName: consultant.consultantName,
        consultantId: consultant.consultantId,
        allocatedZone: consultant.allocatedZone.length > 0 
          ? consultant.allocatedZone.map((zone) => zone.cluster) 
          : [], // Handle empty arrays
      }));
      setConsultants(consultants);
    } catch (error) {
      handleSnackbar("Failed to fetch consultants.", "error");
    }
  };
  

  useEffect(() => {
    fetchConsultants();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    if (name === "username") {
      const selectedConsultant = consultants.find(
        (consultant) => consultant.consultantName === value
      );
      if (selectedConsultant) {
        setSelectedConsultantId(selectedConsultant.consultantId);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { district, block, cluster, username, year, month } = formData;
  
    if (!district || !block || !cluster || !username || !year || !month) {
      handleSnackbar("Please fill out all fields.", "error");
      return;
    }
  
    // Check if the selected consultant is already assigned to the cluster
    const isConsultantAlreadyAssigned = consultants.some(
      (consultant) =>
        consultant.allocatedZone.includes(cluster) && consultant.consultantId === selectedConsultantId
    );
  
    if (isConsultantAlreadyAssigned) {
      handleSnackbar("This consultant is already assigned to the selected cluster.", "error");
      return;
    }
  
    setLoading(true);
    try {
      const body = {
        consultantId: selectedConsultantId,
        consultantName: formData.username,
        district: formData.district,
        block: formData.block,
        cluster: formData.cluster,
        year: formData.year,
        month: formData.month,
      };
  
      const response = await apiPrakasak.post("/allocateConsultant", body);
      if (response?.status === 200) {
        handleSnackbar("Consultant assigned successfully.", "success");
        fetchConsultants(); 
        // Clear the form fields
        // setFormData((prevState) => ({
        //   ...prevState,
        //   cluster: "", 
        //   consultantName: "",
        //   year: "",
        //   month: "",
        // }));
        setFormData({
          district: "", 
          block: "", 
          cluster: "", 
          username: "", 
          year: "", 
          month: "", 
        });
      } else {
        handleSnackbar("Failed to assign consultant.", "error");
      }
    } catch (error) {
      handleSnackbar("Error while assigning consultant.", "error");
    } finally {
      setLoading(false);
    }
  };
  
  
  
  const handleSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
    <Typography variant="h4" gutterBottom align="center">
      User Allocation
    </Typography>
    <Grid container spacing={5}>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Year</InputLabel>
          <Select
            labelId="year-label"
            name="year"
            value={formData.year}
            onChange={handleChange}
          >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        {/* Add a margin here to create space between Year and Month */}
        <Box sx={{ mt: 2 }} />  {/* Adjust the value of mt as needed */}
  
        <FormControl fullWidth>
          <InputLabel id="month-label">Month</InputLabel>
          <Select
            labelId="month-label"
            name="month"
            value={formData.month}
            onChange={handleChange}
          >
            {months.map((month, index) => (
              <MenuItem key={index} value={index + 1}>
                {month}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel id="username-label">Username</InputLabel>
          <Select
            labelId="username-label"
            name="username"
            value={formData.username}
            onChange={handleChange}
          >
            {consultants.map((consultant, index) => (
              <MenuItem key={index} value={consultant.consultantName}>
                {consultant.consultantName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
  
      {formData.username && (
        <>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="district-label">District</InputLabel>
              <Select
                labelId="district-label"
                name="district"
                value={formData.district}
                onChange={handleChange}
              >
                {districts.map((district, index) => (
                  <MenuItem key={index} value={district}>
                    {district}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="block-label">Block</InputLabel>
              <Select
                labelId="block-label"
                name="block"
                value={formData.block}
                onChange={handleChange}
              >
                {blocks.map((block, index) => (
                  <MenuItem key={index} value={block}>
                    {block}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="cluster-label">Cluster</InputLabel>
              <Select
                labelId="cluster-label"
                name="cluster"
                value={formData.cluster}
                onChange={handleChange}
              >
                {clusters.map((cluster, index) => (
                  <MenuItem key={index} value={cluster}>
                    {cluster}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </>
      )}
    </Grid>
    <Box textAlign="center" marginTop={4}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Assigning..." : "Assign Consultant"}
      </Button>
    </Box>
  
    <Snackbar
      open={openSnackbar}
      autoHideDuration={6000}
      onClose={handleSnackbarClose}
    >
      <StyledAlert
        onClose={handleSnackbarClose}
        severity={snackbarSeverity}
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </StyledAlert>
    </Snackbar>
  {consultants.length >0 ?(
   <Box marginTop={15}>
   <TableContainer component={Paper}>
     <Table>
       <TableHead>
         <TableRow>
           <TableCell align="center" sx={{ fontWeight: 'bold', border: '2px solid #ddd' }}>
             Consultant Name
           </TableCell>
           <TableCell align="center" sx={{ fontWeight: 'bold', border: '2px solid #ddd' }}>
             Consultant ID
           </TableCell>
           <TableCell align="center" sx={{ fontWeight: 'bold', border: '2px solid #ddd' }}>
             Allocated Zone
           </TableCell>
         </TableRow>
       </TableHead>
       <TableBody>
         {consultants.map((consultant, index) => (
           <TableRow key={index}>
             <TableCell align="center" sx={{ border: '1px solid #ddd' }}>
               {consultant.consultantName}
             </TableCell>
             <TableCell align="center" sx={{ border: '1px solid #ddd' }}>
               {consultant.consultantId}
             </TableCell>
             <TableCell align="center" sx={{ border: '1px solid #ddd' }}>
               {consultant.allocatedZone.join(", ")}
             </TableCell>
           </TableRow>
         ))}
       </TableBody>
     </Table>
   </TableContainer>
 </Box>
  ):(
    <Box textAlign="center" marginTop={10}>
    <h1>NO RECORD</h1>

      </Box>
  )}
 
  </Container>
  
  );
}